module.exports = __webpack_public_path__ + "img/masterlight.31a77b1.svg";